export default "__VITE_ASSET__DaZIjLRH__"